import loyalty_card from 'shared/assets/images/loyalty-card.jpg'
import dashboard_coupon from 'shared/assets/images/dashboard_coupon.jpg'
import loyalty_card_2x from 'shared/assets/images/loyalty-card@2x.jpg'
import dashboard_coupon_2x from 'shared/assets/images/dashboard_coupon@2x.jpg'
import loyalty_card_3x from 'shared/assets/images/loyalty-card@3x.jpg'
import dashboard_coupon_3x from 'shared/assets/images/dashboard_coupon@3x.jpg'
import challenges from 'shared/assets/images/challenges.jpg'
import challenges_2x from 'shared/assets/images/challenges@2x.jpg'
import challenges_3x from 'shared/assets/images/challenges@3x.jpg'

const kingdomItems = [
    {
        image: [],
        pushed: false,
        categoryId: 'CROWN',
        inMenu: true,
        title: 'kingdom.dashboard.title'
    },
    {
        image: [],
        pushed: false,
        categoryId: 'AVATAR',
        inMenu: true,
        inMenuMobile: true,
        routeId: 'routes.kingdom.information',
        title: 'kingdom.profile.title'
    },
    {
        image: [],
        pushed: false,
        categoryId: 'FIDELITY_CARD',
        inMenu: true,
        inMenuMobile: true,
        routeId: 'routes.kingdom.card',
        title: 'kingdom.loyalty.title'
    },
    {
        image: [],
        pushed: false,
        categoryId: 'CIRCLE_CROWN',
        inMenu: false,
        inMenuMobile: false,
        routeId: 'routes.kingdom.points',
        title: 'kingdom.dashboard.points.title'
    },
    {
        image: [],
        pushed: false,
        categoryId: 'TICKET',
        inMenu: false,
        inMenuMobile: false,
        routeId: 'routes.kingdom.privileges',
        title: 'kingdom.privileges.title'
    },
    {
        image: [],
        pushed: false,
        categoryId: 'ORDERS',
        inMenu: true,
        inMenuMobile: true,
        routeId: 'routes.kingdom.orders',
        title: 'clickandcollect.listorders.title'
    },
    {
        image: [],
        pushed: false,
        categoryId: 'BLAZON',
        inMenu: true,
        inMenuMobile: true,
        routeId: 'routes.kingdom.challenges',
        title: 'kingdom.challenges.title'
    },
    {
        image: [],
        pushed: false,
        categoryId: 'QUESTION',
        inMenu: true,
        inMenuMobile: true,
        routeId: 'routes.question',
        title: 'app.menu.faq'
    },
    {
        image: [loyalty_card, loyalty_card_2x, loyalty_card_3x],
        pushed: true,
        categoryId: 'CARD',
        hasMobileLayout: true,
        routeId: 'routes.kingdom.card',
        title: 'kingdom.card.title',
        tileText: 'kingdom.dashboard.card.text'
    },
    {
        image: [dashboard_coupon, dashboard_coupon_2x, dashboard_coupon_3x],
        pushed: true,
        categoryId: 'TICKET',
        hasMobileLayout: true,
        routeId: 'routes.kingdom.privileges',
        title: 'kingdom.privileges.title',
        tileText: 'kingdom.dashboard.privileges.text'
    },
    {
        image: [challenges, challenges_2x, challenges_3x],
        pushed: true,
        categoryId: 'LOCK',
        routeId: 'routes.kingdom.challenges',
        title: 'kingdom.challenges.title',
        tileText: 'kingdom.dashboard.challenges.text'
    }
]

export { kingdomItems }
